/**
 * Extract "Major.Minor" from a full semver string.
 * "1.4.1" -> "1.4"
 */
export function getMajorMinor(version) {
  const parts = version.split(".");
  return `${parts[0]}.${parts[1]}`;
}

function compareMajorMinor(a, b) {
  const [aMaj, aMin] = a.split(".").map(Number);
  const [bMaj, bMin] = b.split(".").map(Number);
  if (aMaj !== bMaj) return aMaj - bMaj;
  return aMin - bMin;
}

/**
 * Returns true if appVersion (Major.Minor) is newer than lastSeenVersion.
 * lastSeenVersion may be null (never acknowledged).
 */
export function isNewerMajorMinor(appVersion, lastSeenVersion) {
  if (!lastSeenVersion) return true;
  return compareMajorMinor(appVersion, lastSeenVersion) > 0;
}

/**
 * Returns keys from contentMap that are newer than lastSeenVersion and at most
 * maxVersion (current app version), sorted newest-first, capped at 3 entries.
 */
export function getVersionsSince(contentMap, lastSeenVersion, maxVersion) {
  return Object.keys(contentMap)
    .filter((v) =>
      isNewerMajorMinor(v, lastSeenVersion) &&
      compareMajorMinor(v, maxVersion) <= 0
    )
    .sort((a, b) => compareMajorMinor(b, a))
    .slice(0, 3);
}
